export default {
  buttonStyles: {
    customButtonStyles: (vm) => {
      return {
        'border-radius': vm.card ? '8px' : '0px',
        background: !vm.disabled && !vm.selected && !vm.hover ? 'unset' : '#e7b642',
        color: !vm.disabled && !vm.selected && !vm.hover ? '#e7b642' : '#404040',
        border: !vm.hover && !vm.selected && !vm.disabled && !vm.card ? '0px' : '0px',
        'border-color': '#e7b642!important',
        'border-bottom':
          // eslint-disable-next-line no-nested-ternary
          !vm.hover && !vm.selected && !vm.disabled
            ? '4px solid'
            : vm.card && vm.disabled
            ? '0px'
            : '4px solid rgba(0,0,0,0)',
        transition: 'background 0.3s',
        'font-weight': '900!important',
        'font-family': "'Hanken Grotesk', sans-serif!important",
        'text-transform': 'uppercase!important',
      };
    },
  },
  theme: {
    anchor: '#1e88e5' /* blue -- info */,
    accent: {
      base: '#1e88e5' /* blue -- info */,
      darken1: '#979797' /* grey */,
    },
    info: {
      base: '#1e88e5' /* blue */,
      darken1: '#7460ee' /* indigo */,
      darken2: '#563dea' /* dark indigo */,
      darken3: '#6f42c1' /* purple */,
    },
    primary: {
      base: '#e7b642' /* mustard */,

      lighten1: '#6c757d' /* lighter grey for text and menu hover */,
      lighten2: '#FFFFFF' /* white */,
    },
    secondary: {
      base: '#179cb8' /* blue */,
      darken1: '#009b74' /* slightly darker green */,
    },
    error: {
      base: '#fc4b6c' /* red */,
      lighten1: '#e83e8c' /* pink */,
    },
    success: {
      base: '#26c6da' /* sea green */,
      darken1: '#20c997' /* true green */,
    },
    warning: {
      base: '#ffb22b' /* yellow */,
      darken1: '#fd7e14' /* orange */,
      darken2: '#ef5350' /* dark orange */,
    },
    background: 'white' /* white */,
    // '#efedea'
    customGlobalStyles: {
      'font-family': "'Hanken Grotesk', sans-serif!important",
    },
    customStyleSheet: 'vivo',
  },
};
